import Axios from "../baseApi";
export default {
  async create(data) {
    try{
      const response = await Axios.put('/api-master-data/v1/tax', data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async update(id, data) {
    try{
      const response = await Axios.post('/api-master-data/v1/tax/' + id, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async delete(id) {
    try{
      const response = await Axios.delete('/api-master-data/v1/tax/' + id);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async fetch() {
    return await Axios.get('/api-master-data/v1/tax');
  }
}
